import { useEffect, useState, useRef, useCallback } from 'react';

export function useParallax() {
  const [scrollY, setScrollY] = useState(0);
  const rafRef = useRef<number | null>(null);
  const lastScrollY = useRef(0);

  const handleScroll = useCallback(() => {
    // Cancel any pending animation frame to avoid stacking
    if (rafRef.current !== null) {
      return;
    }

    rafRef.current = requestAnimationFrame(() => {
      const currentScrollY = window.scrollY;
      // Only update state if scroll position changed significantly (reduces reflows)
      if (Math.abs(currentScrollY - lastScrollY.current) > 2) {
        lastScrollY.current = currentScrollY;
        setScrollY(currentScrollY);
      }
      rafRef.current = null;
    });
  }, []);

  useEffect(() => {
    // Initial read in rAF to avoid layout thrashing
    rafRef.current = requestAnimationFrame(() => {
      lastScrollY.current = window.scrollY;
      setScrollY(window.scrollY);
      rafRef.current = null;
    });

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [handleScroll]);

  return { scrollY };
}
